import * as countries from "i18n-iso-countries";
import countryDataDe from "i18n-iso-countries/langs/de.json";
import countryDataEn from "i18n-iso-countries/langs/en.json";

export function initCountries() {
  console.log("Initializing countries with German and English translations");
  countries.registerLocale(countryDataDe);
  countries.registerLocale(countryDataEn);
}

export function getCountryName(isoCountryCode: string, lang: string): string {
  return countries.getName(isoCountryCode, lang) || isoCountryCode;
}
